// extracted by mini-css-extract-plugin
export default {"customHeight":"viewTask_customHeight__43x3D","customCarousel":"viewTask_customCarousel__3ITM3","slick-prev":"viewTask_slick-prev__BtMiM","slick-next":"viewTask_slick-next__Jw-Q+"};